import { GcloudAccesses } from "@p0security/integrations-gcloud-shared/accesses";
import { Access, Delegate } from "@p0security/shared/types/access/index";

export const GcpSmAccesses = {
  secret: Access({
    label: "Secret",
    description: "Grant ability to read a secret",
    delegation: {
      gcloud: Delegate({
        resource: "gcloud",
        accesses: GcloudAccesses,
        key: "resource",
      }),
    },
    generated: {},
    maturity: "preview" as const,
    parameters: {
      project: { type: "static", label: "Secret manager project" },
      name: { type: "input", label: "Secret name" },
    },
    render: { locator: "project", policy: "name" } as const,
  }),
};

export type GcpSmAccesses = typeof GcpSmAccesses;
